import * as React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/browser";
import lineLogo from "@/assets/line-logo.png";

import { NonceUtils } from "../../utils/nonce-utils";

type Props = {
  text: string;
};

export const LineAuthButton: React.FC<Props> = (props) => {
  const [disabled, setDisabled] = React.useState<boolean>(false);
  const { t } = useTranslation();

  const toLineLoginPage = () => {
    setDisabled(true);
    try {
      const nonce = NonceUtils.prepareNonce();
      const lineAuthorizeUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&scope=openid email&client_id=${process.env.NEXT_PUBLIC_LINE_CHANNEL_ID}&redirect_uri=${process.env.NEXT_PUBLIC_LINE_REDIRECT_URI}&state=${nonce}`;
      window.location.href = lineAuthorizeUrl;
    } catch (e) {
      toast.error(
        "ブラウザがLINEログインに対応していません。別のブラウザでログインしてください。",
      );
      Sentry.captureMessage(e, "info");
    }
  };

  return (
    <button
      disabled={disabled}
      className="c-auth-button"
      data-testid="line-button"
      onClick={toLineLoginPage}
    >
      <img src={lineLogo} alt="" />
      <span>{props.text}</span>
    </button>
  );
};
